import React, { useId } from 'react';

// Degradê oficial do Instagram (cores da marca)
export const INSTAGRAM_GRADIENT =
  'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)';

const PATH =
  'M128,82a46,46,0,1,0,46,46A46.05239,46.05239,0,0,0,128,82Zm0,68a22,22,0,1,1,22-22A22.02489,22.02489,0,0,1,128,150ZM176,20H80A60.06812,60.06812,0,0,0,20,80v96a60.06812,60.06812,0,0,0,60,60h96a60.06812,60.06812,0,0,0,60-60V80A60.06812,60.06812,0,0,0,176,20Zm36,156a36.04061,36.04061,0,0,1-36,36H80a36.04061,36.04061,0,0,1-36-36V80A36.04061,36.04061,0,0,1,80,44h96a36.04061,36.04061,0,0,1,36,36ZM196,76a16,16,0,1,1-16-16A16.01833,16.01833,0,0,1,196,76Z';

interface Props {
  className?: string;
  /** gradient = ícone com degradê; white = ícone branco (para usar sobre fundo em degradê) */
  variant?: 'gradient' | 'white';
}

const InstagramIcon: React.FC<Props> = ({ className, variant = 'gradient' }) => {
  const id = useId().replace(/:/g, '');
  return (
    <svg viewBox="0 0 256 256" className={className} aria-label="Instagram" role="img">
      {variant === 'gradient' && (
        <defs>
          <radialGradient id={`ig-${id}`} cx="30%" cy="107%" r="150%">
            <stop offset="0%" stopColor="#fdf497" />
            <stop offset="5%" stopColor="#fdf497" />
            <stop offset="45%" stopColor="#fd5949" />
            <stop offset="60%" stopColor="#d6249f" />
            <stop offset="90%" stopColor="#285AEB" />
          </radialGradient>
        </defs>
      )}
      <path d={PATH} fill={variant === 'gradient' ? `url(#ig-${id})` : '#ffffff'} />
    </svg>
  );
};

export default InstagramIcon;
